var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 417,
    viewBox: "0 0 426 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.47 270.04V120.8L251.58 0L182.36 120.8V132.77V270.04",
    fill: "#2E3191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.47 270.04V322.9H281.72H223.82H182.36V270.04",
    fill: "#2E3191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3201 262.07V322.9H107.94H146.51H173.65V135.63L80.3201 262.07Z",
    fill: "#2E3191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 262.15V322.98H397.71H359.15H332.01V135.7L425.33 262.15Z",
    fill: "#00ADEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.08 351.61L102.18 368.06H98.29L90.43 351.61V370.55H83.91V340.45H92.73L100.25 356.98L107.81 340.45H116.59V370.55H110.07V351.61H110.08Z",
    fill: "#2E368F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.11 370.55H129.59V358.67L119.48 340.46H126.54L132.85 351.65L139.16 340.46H146.22L136.11 358.67V370.55Z",
    fill: "#2E368F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2 344.4C184.99 347.03 186.38 350.68 186.38 355.36C186.38 360.04 185.02 363.74 182.3 366.47C179.58 369.2 175.44 370.56 169.87 370.56H159.88V340.46H170.2C175.41 340.46 179.41 341.77 182.19 344.4H182.2ZM177.42 362.29C179.02 360.74 179.82 358.49 179.82 355.53C179.82 352.57 179.02 350.3 177.42 348.71C175.82 347.12 173.36 346.32 170.04 346.32H166.4V364.62H170.54C173.52 364.62 175.81 363.84 177.41 362.29H177.42Z",
    fill: "#2E368F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.77 340.46H198.29V370.56H191.77V340.46Z",
    fill: "#2E368F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.2 355.23H230.76V365.91C227.86 369.24 223.85 370.91 218.73 370.91C214.44 370.91 210.84 369.45 207.93 366.52C205.02 363.59 203.56 359.9 203.56 355.43C203.56 350.96 205.04 347.24 208.01 344.26C210.98 341.27 214.56 339.78 218.75 339.78C222.94 339.78 226.58 341.2 229.68 344.04L226.3 349.08C224.99 347.9 223.79 347.09 222.68 346.65C221.57 346.21 220.39 345.98 219.11 345.98C216.63 345.98 214.54 346.85 212.84 348.59C211.14 350.33 210.29 352.62 210.29 355.46C210.29 358.3 211.1 360.58 212.73 362.28C214.36 363.99 216.3 364.84 218.56 364.84C220.82 364.84 222.7 364.4 224.2 363.51V355.24V355.23Z",
    fill: "#2E368F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M236.32 340.46H242.84V370.56H236.32V340.46Z",
    fill: "#2E368F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M262.14 346.27V370.55H255.62V346.27H247.35V340.46H270.42V346.27H262.15H262.14Z",
    fill: "#2E368F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M293.61 370.55L290.89 364.05H278.65L275.93 370.55H268.99L281.61 340.45H287.92L300.54 370.55H293.6H293.61ZM284.79 349.41L281.11 358.15H288.42L284.78 349.41H284.79Z",
    fill: "#2E368F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.68 370.55V340.45H310.2V364.56H322.65V370.54H303.68V370.55Z",
    fill: "#2E368F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77 388.3C91.08 388.88 90.74 389.65 90.74 390.62C90.74 391.59 91.16 392.34 92 392.91C92.84 393.48 94.78 394.15 97.82 394.92C100.86 395.69 103.22 396.85 104.91 398.39C106.59 399.93 107.43 402.19 107.43 405.15C107.43 408.11 106.35 410.51 104.2 412.36C102.04 414.2 99.21 415.12 95.69 415.12C90.61 415.12 86.04 413.18 81.98 409.31L86.24 403.92C89.7 407.04 92.89 408.6 95.82 408.6C97.13 408.6 98.17 408.31 98.92 407.73C99.67 407.15 100.04 406.36 100.04 405.37C100.04 404.38 99.64 403.59 98.85 403.01C98.05 402.43 96.48 401.84 94.13 401.24C90.4 400.33 87.67 399.14 85.94 397.67C84.21 396.21 83.35 393.91 83.35 390.77C83.35 387.63 84.44 385.22 86.63 383.52C88.82 381.82 91.55 380.97 94.82 380.97C96.96 380.97 99.1 381.35 101.24 382.1C103.38 382.86 105.24 383.93 106.83 385.31L103.21 390.7C100.43 388.53 97.55 387.44 94.59 387.44C93.4 387.44 92.46 387.73 91.77 388.31V388.3Z",
    fill: "#2E368F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.73 408.21C134.25 408.21 137.12 406.78 139.35 403.91L143.94 408.78C140.3 413 136.01 415.11 131.08 415.11C126.15 415.11 122.08 413.5 118.88 410.29C115.68 407.08 114.09 403.02 114.09 398.12C114.09 393.22 115.72 389.13 118.97 385.86C122.23 382.58 126.21 380.95 130.92 380.95C136.18 380.95 140.58 383.01 144.13 387.14L139.68 392.34C137.42 389.44 134.6 387.99 131.24 387.99C128.55 387.99 126.25 388.9 124.34 390.71C122.43 392.52 121.47 394.96 121.47 398.03C121.47 401.1 122.37 403.57 124.18 405.43C125.98 407.29 128.17 408.22 130.74 408.22L130.73 408.21Z",
    fill: "#2E368F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.95 381.71H179.1V414.74H171.95V401.75H159.2V414.74H152.05V381.71H159.2V395.51H171.95V381.71Z",
    fill: "#2E368F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.44 410.18C213.2 413.44 209.21 415.07 204.47 415.07C199.73 415.07 195.74 413.44 192.5 410.18C189.26 406.92 187.64 402.86 187.64 398.01C187.64 393.16 189.26 389.1 192.5 385.84C195.74 382.58 199.73 380.95 204.47 380.95C209.21 380.95 213.2 382.58 216.44 385.84C219.68 389.1 221.3 393.16 221.3 398.01C221.3 402.86 219.68 406.92 216.44 410.18ZM214.01 398.03C214.01 395.09 213.09 392.57 211.26 390.49C209.43 388.41 207.17 387.37 204.5 387.37C201.83 387.37 199.57 388.41 197.74 390.49C195.91 392.57 194.99 395.08 194.99 398.03C194.99 400.98 195.91 403.48 197.74 405.54C199.57 407.6 201.83 408.63 204.5 408.63C207.17 408.63 209.43 407.6 211.26 405.54C213.09 403.48 214.01 400.97 214.01 398.03Z",
    fill: "#2E368F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.8 410.18C253.56 413.44 249.57 415.07 244.83 415.07C240.09 415.07 236.1 413.44 232.86 410.18C229.62 406.92 228 402.86 228 398.01C228 393.16 229.62 389.1 232.86 385.84C236.1 382.58 240.09 380.95 244.83 380.95C249.57 380.95 253.56 382.58 256.8 385.84C260.04 389.1 261.66 393.16 261.66 398.01C261.66 402.86 260.04 406.92 256.8 410.18ZM254.37 398.03C254.37 395.09 253.45 392.57 251.62 390.49C249.79 388.41 247.53 387.37 244.86 387.37C242.19 387.37 239.93 388.41 238.1 390.49C236.27 392.57 235.35 395.08 235.35 398.03C235.35 400.98 236.27 403.48 238.1 405.54C239.93 407.6 242.19 408.63 244.86 408.63C247.53 408.63 249.79 407.6 251.62 405.54C253.45 403.48 254.37 400.97 254.37 398.03Z",
    fill: "#2E368F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.19 414.74V381.71H277.34V408.17H291.01V414.74H270.19Z",
    fill: "#2E368F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M306.21 388.3C305.52 388.88 305.18 389.65 305.18 390.62C305.18 391.59 305.6 392.34 306.44 392.91C307.28 393.48 309.22 394.15 312.26 394.92C315.3 395.69 317.66 396.85 319.35 398.39C321.03 399.93 321.87 402.19 321.87 405.15C321.87 408.11 320.79 410.51 318.64 412.36C316.48 414.2 313.65 415.12 310.13 415.12C305.05 415.12 300.48 413.18 296.42 409.31L300.68 403.92C304.14 407.04 307.33 408.6 310.26 408.6C311.57 408.6 312.61 408.31 313.36 407.73C314.11 407.15 314.48 406.36 314.48 405.37C314.48 404.38 314.08 403.59 313.29 403.01C312.49 402.43 310.92 401.84 308.57 401.24C304.84 400.33 302.11 399.14 300.38 397.67C298.65 396.21 297.79 393.91 297.79 390.77C297.79 387.63 298.88 385.22 301.07 383.52C303.26 381.82 305.99 380.97 309.26 380.97C311.4 380.97 313.54 381.35 315.68 382.1C317.82 382.86 319.68 383.93 321.27 385.31L317.65 390.7C314.87 388.53 311.99 387.44 309.03 387.44C307.84 387.44 306.9 387.73 306.21 388.31V388.3Z",
    fill: "#2E368F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.58 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.51 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M269.43 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.35 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M287.27 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M296.19 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305.12 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M305.18 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M314.1 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M323.02 0V322.9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M173.65 259.58H5.35999",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64 253.94C2.53 253.94 0 256.47 0 259.58C0 262.69 2.53 265.22 5.64 265.22C8.75 265.22 11.28 262.69 11.28 259.58C11.28 256.47 8.75 253.94 5.64 253.94Z",
    fill: "#00ADEE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.65 275.25H46.95",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.65 290.91H5.35999",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64 285.27C2.53 285.27 0 287.8 0 290.91C0 294.02 2.53 296.55 5.64 296.55C8.75 296.55 11.28 294.02 11.28 290.91C11.28 287.8 8.75 285.27 5.64 285.27Z",
    fill: "#00ADEE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.65 306.57H46.95",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M173.65 322.23H32.19",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.47 327.87C35.5849 327.87 38.11 325.345 38.11 322.23C38.11 319.115 35.5849 316.59 32.47 316.59C29.3551 316.59 26.83 319.115 26.83 322.23C26.83 325.345 29.3551 327.87 32.47 327.87Z",
    fill: "#00ADEE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M345.86 250.16V411.09",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M340.22 410.81C340.22 413.92 342.75 416.45 345.86 416.45C348.97 416.45 351.5 413.92 351.5 410.81C351.5 407.7 348.97 405.17 345.86 405.17C342.75 405.17 340.22 407.7 340.22 410.81Z",
    fill: "#00ADEE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M362.26 250.16V371.49",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M378.67 250.16V411.09",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M373.03 410.81C373.03 413.92 375.56 416.45 378.67 416.45C381.78 416.45 384.31 413.92 384.31 410.81C384.31 407.7 381.78 405.17 378.67 405.17C375.56 405.17 373.03 407.7 373.03 410.81Z",
    fill: "#00ADEE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M395.07 250.16V371.49",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M411.48 250.16V385.4",
    stroke: "#00ADEE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M405.84 385.12C405.84 388.23 408.37 390.759 411.48 390.759C414.59 390.759 417.12 388.23 417.12 385.12C417.12 382.01 414.59 379.479 411.48 379.479C408.37 379.479 405.84 382.01 405.84 385.12Z",
    fill: "#00ADEE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 228.72H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 244.38H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 260.04H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 275.7H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 291.37H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33 307.03H332.01",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27 165.53H183.9V188.26H206.27V165.53Z",
    fill: "#00ADEE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M228.64 187.12H206.27V209.85H228.64V187.12Z",
    fill: "#00ADEE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M251.01 165.53H228.64V188.26H251.01V165.53Z",
    fill: "#00ADEE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27 209.85H183.9V232.58H206.27V209.85Z",
    fill: "#00ADEE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M228.64 231.439H206.27V254.169H228.64V231.439Z",
    fill: "#00ADEE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M251.01 209.85H228.64V232.58H251.01V209.85Z",
    fill: "#00ADEE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27 254.17H183.9V276.9H206.27V254.17Z",
    fill: "#00ADEE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M228.64 275.76H206.27V298.49H228.64V275.76Z",
    fill: "#00ADEE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M251.01 254.17H228.64V276.9H251.01V254.17Z",
    fill: "#00ADEE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M251.02 297.48H228.29V320.21H251.02V297.48Z",
    fill: "#00ADEE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27 120.58H183.9V143.31H206.27V120.58Z",
    fill: "#00ADEE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M228.64 142.18H206.27V164.91H228.64V142.18Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e57aaf71c518943cc2cc4ba078b731a7.svg";
export { ForwardRef as ReactComponent };